export default __webpack_public_path__ + "static/media/rub-icon.e1f0a15c.svg";